// extracted by mini-css-extract-plugin
module.exports = {"scale":"0.5"};